module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AMj3c1/tc-custom/9781617456183.jpg?1725275783926",
      "alt": "This image is the cover for the book Sweet & Simple Wool Appliqué"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sweet & Simple Wool Appliqué\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Master the art of wool appliqué with this step-by-step guide featuring a range of projects by some of today’s top designers.")]), _c('br'), _c('br'), _vm._v("From traditional pincushions to playful embellishments on a contemporary blue jean jacket, this delightful book offers something for everyone. The 16 featured projects present a full range of challenges for all skill levels, whether you want to try wool appliqué for the first time or you’re an experienced wool fanatic. "), _c('br'), _c('br'), _vm._v("Projects include everything from a table runner, a pillow, and pinkeeps to a needle book, a notebook cover, a wallhanging-sized quilt, and more. Contributing designers include Lori Brechlin, Annie Downs, Stacy Nash, Marlene Strauser, and more."), _c('br'), _c('br'), _c('b', [_vm._v("This eBook edition includes links to printable appliqué patterns.")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      C&T Publishing\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0